var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"plain-message-wrapper"},[_c('div',{staticClass:"content u-b1",domProps:{"innerHTML":_vm._s(_vm.plainMessage.text)}}),_c('AttachmentList',{attrs:{"attachments":_vm.plainMessage.attachments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }